import React from "react";
import { Skeleton } from "@arco-design/web-react";
import Content from "./Content";

// A calm page-load placeholder used in place of a bare spinner — a title line
// plus a few content rows, so a loading screen hints at the layout to come.
export default function LoadingState({ rows = 5 }) {
  return (
    <Content>
      <Skeleton
        animation
        text={{ rows: 1, width: ["30%"] }}
        style={{ marginBottom: 20 }}
      />
      <Skeleton
        animation
        text={{ rows, width: ["100%", "92%", "96%", "70%", "84%"] }}
      />
    </Content>
  );
}
